/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unstable-nested-components */
import React, { useState, useCallback, useEffect } from 'react';
import {
  Grid, Dialog, DialogTitle, DialogContent, LinearProgress,
} from '@mui/material';
import ParamDialogContent from '../pages/measurement/paramDialog/paramDialogContent';
import CustomPoper from './CustomPoper';
import MultiSelectAll from './MultiSelect';
import { labelField } from 'utils';

export default function AutocompleteParameters(data) {
  const [options, setOptions] = useState(data.options);
  const [values, setValues] = useState(data.parameters);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [iteracao, setIteracao] = useState(0);
  const [openPondModal, setOpenPondModal] = useState(false);
  const [openLinearProgress, setOpenLinearProgress] = useState(false);
  const [openAutocomplete, setOpenAutocomplete] = useState(false);

  useEffect(() => {
    setIteracao(iteracao + 1);
    if (values.length === 0 && iteracao > 1) data.parametersIsNull[1](true);
    else data.parametersIsNull[1](false);
  }, [values]);

  useEffect(() => {
    setOptions(data.options);
  }, [data.options]);

  useEffect(() => {
    setValues(data.parameters);
  }, [data.parameters]);

  /**
* @param {React.ChangeEvent<{}>} event
* @param {AutocompleteChangeReason} reason
*/
  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick') {
      setOpenPondModal(false);
    }
    if (reason === 'escapeKeyDown') {
      setOpenPondModal(false);
    }
  };

  return (
    <Grid item xs>
      <Dialog
        style={{ padding: '15rem' }}
        open={openPondModal}
        fullWidth
        maxWidth="lg"
        onClose={handleCloseModal}
      >
        {openLinearProgress && <LinearProgress />}
        <DialogTitle style={{ paddingBottom: '0' }}>
          <span style={{ paddingLeft: '1rem' }}>
            Dados do Parâmetro
          </span>
        </DialogTitle>
        <DialogContent>
          <ParamDialogContent
            setForms={(payload) => {
              if (data.type) {
                const filteredPayload = payload.type.includes(data.type) ? [payload, ...options] : [...options];
                setOptions(filteredPayload);
              } else {
                setOptions([payload, ...options]);
              }
            }}
            typeName={data.type}
            setOpenPondModal={setOpenPondModal}
            setOpenAutocomplete={setOpenAutocomplete}
            setOpenLinearProgress={setOpenLinearProgress}
          />
        </DialogContent>
      </Dialog>
      <MultiSelectAll
        open={openAutocomplete}
        onOpen={() => {
          setOpenAutocomplete((state) => !state);
        }}
        onClose={() => {
          setOpenAutocomplete((state) => !state);
        }}
        allSelected={options.length === values.length}
        size="medium"
        label={labelField('Parâmetros')}
        labelOption="name"
        isOptionEqualToValue={(option, value) => value.id === option.id}
        options={options}
        value={values}
        onChange={data.callback}
        error={data.parametersIsNull[0]}
        helperText={data.parametersIsNull[0] && 'Campo Obrigatório'}
        renderOptionLabel={(option) => `${option.name} ${option.name.includes('Selecionar todos') ? '' : `(${option.unity.sigla})`}`}
        PopperComponent={(param) => (
          <CustomPoper
            labelLink="Cadastrar Parâmetro"
            labelPopper={options.length === 0
              ? 'Não existe parâmetro cadastrado nessa medição.'
              : 'Deseja cadastrar outro parâmetro?'}
            setOpenModal={() => {
              setOpenPondModal((state) => !state);
            }}
            {...param}
          />
        )}
      />
    </Grid>
  );
}
